export default __webpack_public_path__ + "static/media/BASF-Logo.f56e5e1c.png";